import * as React from "react"
import { graphql } from "gatsby";
import Layout from "../components/Layout"
import { SmallBar } from "../components/PageEnd/PageEnd"
import MainPageHeader from "../components/MainPageHeader/MainPageHeader"

const TermsOfUsePage = ({data}) => {
  return (
      <Layout>
        <MainPageHeader 
          title={<><span className="font-extralight">Terms of</span> Use</>} 
          image={'https://content.theinformationlab.co.uk/images/hero_legal_70356eeeb9.png'} 
          accentColour={'blue'}
        />
        <div className="bg-white mb-14 lg:mb-32">
            <div className="max-full xl:mx-auto xl:max-w-7xl">
                <div className="max-w-[780px] mx-auto text-blue-700">This policy was last updated on { data?.strapiTermsOfUse?.updatedAt}</div>
                <div className="max-w-[780px] mx-auto policy-text" dangerouslySetInnerHTML={{__html: data?.strapiTermsOfUse?.Terms?.data?.Terms}} />
            </div>
        </div>
        <SmallBar />
      </Layout>
  )
}

export default TermsOfUsePage

export const Head = () => <title>The Data School - Terms of Use</title>

export const query = graphql`
  query TermsOfUseQuery {
    strapiTermsOfUse {
    Terms {
      data {
        Terms
      }
    }
    updatedAt(formatString: "Do MMMM YYYY")
  }
}
`
